module.exports = __webpack_public_path__ + "static/media/Slide65.a7961e82.JPG";